import SearchPlanos from './SearchPlanos';

export default SearchPlanos;